import { CustomerQuestionnaireEdit } from '../translations-types';

const translations: CustomerQuestionnaireEdit = {
  editQuestionnaireSubmission: 'Edit questionnaire submission',
};

export default translations;
